<template>
    <div class="pp-content">
        <div class="pp-header pp-header--simple pp-header-image-generic pp-header--mobile-small">
            <div class="pp-header__title">
                {{ account ? account.name : 'Guest' }}
            </div>
        </div>
        <div v-if="!account" class="pp-content__page">
            <div class="pp-account">
                <div class="pp-account__row">
                    <div class="pp-account__header">
                        Free plays remaining
                    </div>
                    <div class="pp-account__value">
                        {{ freePlays }}
                    </div>
                </div>
                <a v-if="$root.view == 'mobile'" href="https://www.pristineclassical.com/pages/player-auth?mode=mobile" class="pp-account__button">
                    Login
                </a>
                <a v-if="$root.view == 'desktop'" href="https://www.pristineclassical.com/pages/player-auth" class="pp-account__button">
                    Login
                </a>
                <a  v-if="$root.view == 'desktop' && !$root.isIos" href="https://www.pristineclassical.com/account/register" target="_blank" class="pp-account__button">
                    Create account
                </a>
                <a  v-if="$root.view == 'mobile' && !$root.isIos" href="https://www.pristineclassical.com/pages/player-signup?from_page=subscribe&mode=mobile" class="pp-account__button">
                    Create account
                </a>
            </div>
        </div>
        <div v-if="account" class="pp-content__page">
            <div class="pp-account">
                <div class="pp-account__row">
                    <div class="pp-account__header">
                        Plan
                    </div>
                    <div class="pp-account__value">
                        {{ account.plan }}
                    </div>
                </div>
                <button @click="logout" class="pp-account__button pp-account__button--outline">
                    Logout
                </button>
            </div>
        </div>
    </div>

</template>


<script>
import { api } from '../API.js';
import EventBus from '../EventBus.js';

export default {
    name: 'account',
    data() {
        return {
            freePlays: null,
            account: {
                name: null,
                id: null,
                plan: null
            }
        };
    },
    mounted() {
        this.fetchData();

        EventBus.on('account.freePlaysChanged', (e) => {
            console.log('account.freePlaysChanged', e);
            this.freePlays = e.data.freePlays;
            console.log('account.freePlaysChanged', this);
        });

        EventBus.on('auth.success', (e) => {
            this.account = api.account;
        })
    },
    watch: {
        '$route': () => { this.fetchData(); }
    },
    methods: {
        fetchData() {
            this.account = api.account;
        },


        logout() {
            EventBus.emit('auth.triggerLogout', {});
        }
    }
}
</script>



// WEBPACK FOOTER //
// Account.vue?f189bcdc